import { ApiCommunications, FileResponse, NullPromise } from '../../webmodule-common/interop/webmodule-interop';
import { tenantId } from '../../webmodule-common/other/api/current-user';
import {
  Branch,
  InputAddBranchQuoteSupport,
  InputCreateBranch,
  InputCreateBranchQuote,
  InputCSVProducer,
  InputDeleteBranchQuote,
  InputDeleteDraftBranchQuoteSupport,
  InputDuplicateBranchQuoteSupport,
  InputDuplicateConversation,
  InputGetActiveUserInformation,
  InputGetConcurrencyCheck,
  InputLockResource,
  InputQueueCleanupConversationAttachments,
  InputQuoteItemConversation,
  InputResolveBranchQuoteSupport,
  InputUnLockResource,
  InputUpdateBranch,
  InputUpdateBranchQuote,
  InputUpdateBranchQuoteDefaults,
  InputUpdateBranchQuoteSupport,
  InputUpdateFranchisee,
  InputUpdateFranchiseeConfiguration,
  InputUpdateFranchiseeProperties,
  InputUpdateStock,
  QuoteItemConversation,
  RequestConversation,
  RequestGetAllLinkedQuoteItemsForConversation,
  RequestGetBranch,
  RequestGetBranchQuotes,
  RequestGetBranchQuoteSupport,
  RequestGetBranchQuoteSupportInbox,
  RequestGetPurchaseOrderUserIdsByBranchId,
  RequestGetPurchaseOrderUserIdsByBranchIds,
  RequestGetStock,
  RequestLookupStock,
  ResultBranchQuoteSupport,
  ResultConversation,
  ResultCreateBranchQuote,
  ResultDealerSystemConfiguration,
  ResultDeleteBranchQuote,
  ResultDuplicateBranchQuoteSupport,
  ResultDuplicateConversation,
  ResultGetActiveUserInformation,
  ResultGetAllLinkedQuoteItemsForConversation,
  ResultGetBranch,
  ResultGetBranches,
  ResultGetBranchQuoteDefaults,
  ResultGetBranchQuotes,
  ResultGetBranchQuoteSupport,
  ResultGetBranchQuoteSupportInbox,
  ResultGetConcurrencyCheck,
  ResultGetFranchisee,
  ResultGetFranchiseeConfiguration,
  ResultGetPurchaseOrderUserIdsByBranchId,
  ResultGetPurchaseOrderUserIdsByBranchIds,
  ResultGetStock,
  ResultLockResource,
  ResultLookupStock,
  ResultQueueCleanupConversationAttachments,
  ResultResolveBranchQuoteSupport,
  ResultUnLockResource,
  ResultUpdateBranch,
  ResultUpdateBranchQuote,
  ResultUpdateBranchQuoteDefaults,
  ResultUpdateFranchisee,
  ResultUpdateFranchiseeConfiguration,
  ResultUpdateFranchiseeProperties,
  ResultUpdateStock
} from './dealer-api-interface-franchisee';
import { FranchiseeApi } from './franchisee-api';

export class DealerFranchiseeApi implements FranchiseeApi {
  franchiseeApiPath = 'api/Franchisee/';
  conversationApiPath = 'api/Conversation/';
  conversionApiPath = 'api/Conversion/';
  api: ApiCommunications;

  constructor(api: ApiCommunications) {
    this.api = api;
  }

  async convertToCsv(input: InputCSVProducer): NullPromise<FileResponse> {
    return await this.api.postFileDownload(`${this.conversionApiPath}ConvertToCsv`, input);
  }
  async lockResource(input: InputLockResource): NullPromise<ResultLockResource> {
    return await this.api.post<ResultLockResource>(`${this.franchiseeApiPath}ResourceLock/Lock`, input);
  }
  async unlockResource(input: InputUnLockResource): NullPromise<ResultUnLockResource> {
    return await this.api.post<ResultLockResource>(`${this.franchiseeApiPath}ResourceLock/UnLock`, input);
  }
  async getConcurrencyCheck(input: InputGetConcurrencyCheck): NullPromise<ResultGetConcurrencyCheck> {
    return await this.api.post<ResultGetConcurrencyCheck>(
      `${this.franchiseeApiPath}ResourceLock/concurrency-check`,
      input
    );
  }
  async getBranchQuoteDefaults(
    branchId: string,
    supplierId: string,
    systemUserId: string
  ): NullPromise<ResultGetBranchQuoteDefaults> {
    return await this.api.post<ResultGetBranchQuoteDefaults>(`${this.franchiseeApiPath}Quote/GetBranchQuoteDefaults`, {
      branchId,
      supplierId,
      systemUserId
    });
  }
  async updateBranchQuoteDefaults(
    defaults: InputUpdateBranchQuoteDefaults
  ): NullPromise<ResultUpdateBranchQuoteDefaults> {
    return await this.api.post<ResultUpdateBranchQuoteDefaults>(
      `${this.franchiseeApiPath}Quote/UpdateBranchQuoteDefaults`,
      defaults
    );
  }

  async getBranchQuotes(input: RequestGetBranchQuotes): NullPromise<ResultGetBranchQuotes> {
    return await this.api.post<ResultGetBranchQuotes>(`${this.franchiseeApiPath}GetBranchQuotes`, input);
  }
  async getActiveUserInformation(input: InputGetActiveUserInformation): NullPromise<ResultGetActiveUserInformation> {
    return await this.api.post<ResultGetActiveUserInformation>(
      `${this.franchiseeApiPath}GetActiveUserInformation`,
      input
    );
  }

  async getFranchisee(): NullPromise<ResultGetFranchisee> {
    return await this.api.post<ResultGetFranchisee>(`${this.franchiseeApiPath}GetFranchisee`, {});
  }

  async getFranchiseeConfiguration(): NullPromise<ResultGetFranchiseeConfiguration> {
    return await this.api.post<ResultGetFranchiseeConfiguration>(
      `${this.franchiseeApiPath}GetFranchiseeConfiguration`,
      {}
    );
  }

  async updateFranchisee(body: InputUpdateFranchisee): NullPromise<ResultUpdateFranchisee> {
    return await this.api.post<ResultUpdateFranchisee>(`${this.franchiseeApiPath}UpdateFranchisee`, body);
  }
  async updateFranchiseePropreties(
    body: InputUpdateFranchiseeProperties
  ): NullPromise<ResultUpdateFranchiseeProperties> {
    return await this.api.post<ResultUpdateFranchiseeProperties>(
      `${this.franchiseeApiPath}UpdateFranchiseeProperties`,
      body
    );
  }

  async updateFranchiseeConfiguration(
    body: InputUpdateFranchiseeConfiguration
  ): NullPromise<ResultUpdateFranchiseeConfiguration> {
    return await this.api.post<ResultUpdateFranchiseeConfiguration>(
      `${this.franchiseeApiPath}UpdateFranchiseeConfiguration`,
      body
    );
  }

  async getSystemConfiguration(): NullPromise<ResultDealerSystemConfiguration> {
    return await this.api.post<ResultDealerSystemConfiguration>(`${this.franchiseeApiPath}GetSystemConfiguration`, {});
  }

  async getBranches(): NullPromise<ResultGetBranches> {
    return await this.api.post<ResultGetBranches>(`${this.franchiseeApiPath}GetBranches`, {});
  }

  async getBranch(body: RequestGetBranch): NullPromise<ResultGetBranch> {
    return await this.api.post<ResultGetBranch>(`${this.franchiseeApiPath}GetBranch`, body);
  }

  async updateBranch(body: InputUpdateBranch): NullPromise<Branch> {
    return (await this.api.post<ResultUpdateBranch>(`${this.franchiseeApiPath}UpdateBranch`, body))?.branch ?? null;
  }

  async createBranch(body: InputCreateBranch): NullPromise<Branch> {
    return (await this.api.post<ResultUpdateBranch>(`${this.franchiseeApiPath}CreateBranch`, body))?.branch ?? null;
  }

  createBrandingLogoImagePath(fileName: string, extension: string): string {
    const date = new Date().getTime();
    return `T${tenantId()}/services/franchisee/logo/${date}/${fileName}.${extension}`;
  }

  async createBranchQuote(input: InputCreateBranchQuote): NullPromise<ResultCreateBranchQuote> {
    return await this.api.post<ResultCreateBranchQuote>(`${this.franchiseeApiPath}CreateBranchQuote`, input);
  }
  async updateBranchQuote(input: InputUpdateBranchQuote): NullPromise<ResultUpdateBranchQuote> {
    return await this.api.post<ResultUpdateBranchQuote>(`${this.franchiseeApiPath}UpdateBranchQuote`, input);
  }
  async deleteBranchQuote(input: InputDeleteBranchQuote): NullPromise<ResultDeleteBranchQuote> {
    return await this.api.post<ResultUpdateBranchQuote>(`${this.franchiseeApiPath}DeleteBranchQuote`, input);
  }

  getFranchiseeImagePath(fileName: string, extension: string): string {
    return this.api.fullUrl(`api/file/T${tenantId()}/services/franchisee/images/${fileName}.${extension}`);
  }

  async getStock(input: RequestGetStock): NullPromise<ResultGetStock> {
    return await this.api.post<ResultGetStock>(`${this.franchiseeApiPath}GetStock`, input);
  }

  async updateStock(input: InputUpdateStock): NullPromise<ResultUpdateStock> {
    return await this.api.post<ResultUpdateStock>(`${this.franchiseeApiPath}UpdateStock`, input);
  }

  async lookupStock(input: RequestLookupStock): NullPromise<ResultLookupStock> {
    return await this.api.post<ResultLookupStock>(`${this.franchiseeApiPath}GetLookupStock`, input);
  }

  async addBranchQuoteSupport(input: InputAddBranchQuoteSupport): NullPromise<ResultBranchQuoteSupport> {
    return await this.api.post<ResultBranchQuoteSupport>(`${this.conversationApiPath}addBranchQuoteSupport`, input);
  }
  async updateBranchQuoteSupport(input: InputUpdateBranchQuoteSupport): NullPromise<ResultBranchQuoteSupport> {
    return await this.api.post<ResultBranchQuoteSupport>(`${this.conversationApiPath}updateBranchQuoteSupport`, input);
  }

  async getBranchQuoteSupport(input: RequestGetBranchQuoteSupport): NullPromise<ResultGetBranchQuoteSupport> {
    return await this.api.post<ResultGetBranchQuoteSupport>(`${this.conversationApiPath}getBranchQuoteSupport`, input);
  }
  async deleteDraftBranchQuoteSupport(input: InputDeleteDraftBranchQuoteSupport): NullPromise<{}> {
    return await this.api.post<ResultGetBranchQuoteSupport>(
      `${this.conversationApiPath}deleteDraftBranchQuoteSupport`,
      input
    );
  }
  async getConversation(input: RequestConversation): NullPromise<ResultConversation> {
    return await this.api.post<ResultConversation>(`${this.conversationApiPath}getConversation`, input);
  }
  async duplicateConversation(input: InputDuplicateConversation): NullPromise<ResultDuplicateConversation> {
    return await this.api.post<ResultDuplicateConversation>(`${this.conversationApiPath}DuplicateConversation`, input);
  }
  async duplicateBranchQuoteSupport(
    input: InputDuplicateBranchQuoteSupport
  ): NullPromise<ResultDuplicateBranchQuoteSupport> {
    return await this.api.post<ResultDuplicateBranchQuoteSupport>(
      `${this.conversationApiPath}DuplicateBranchQuoteSupport`,
      input
    );
  }

  async resolveBranchQuoteSupport(input: InputResolveBranchQuoteSupport): NullPromise<ResultResolveBranchQuoteSupport> {
    return await this.api.post<ResultResolveBranchQuoteSupport>(
      `${this.conversationApiPath}ResolveBranchQuoteSupport`,
      input
    );
  }

  async queueCleanupConversationAttachments(input: InputQueueCleanupConversationAttachments): Promise<void> {
    await this.api.post<ResultQueueCleanupConversationAttachments>(
      `${this.conversationApiPath}QueueCleanupConversationAttachments`,
      input
    );
  }
  async quoteItemConversationLink(input: InputQuoteItemConversation): NullPromise<QuoteItemConversation> {
    return await this.api.post<QuoteItemConversation>(`${this.conversationApiPath}quoteItemConversationLink`, input);
  }

  async getAllLinkedQuoteItemsForConversation(
    input: RequestGetAllLinkedQuoteItemsForConversation
  ): NullPromise<ResultGetAllLinkedQuoteItemsForConversation> {
    return await this.api.post<ResultGetAllLinkedQuoteItemsForConversation>(
      `${this.conversationApiPath}GetAllLinkedQuoteItemsForConversation`,
      input
    );
  }
  get getConversationAttachmentUploadURL(): string {
    return this.api.fullUrl(`${this.conversationApiPath}UploadAttachment`);
  }

  async getPurchaseOrderUserIdsByBranchId(
    input: RequestGetPurchaseOrderUserIdsByBranchId
  ): NullPromise<ResultGetPurchaseOrderUserIdsByBranchId> {
    return this.api.post<ResultGetPurchaseOrderUserIdsByBranchId>(
      `${this.franchiseeApiPath}GetPurchaseOrderUserIdsByBranchId`,
      input
    );
  }
  async getPurchaseOrderUserIdsByBranchIds(
    input: RequestGetPurchaseOrderUserIdsByBranchIds
  ): NullPromise<ResultGetPurchaseOrderUserIdsByBranchIds> {
    return this.api.post<ResultGetPurchaseOrderUserIdsByBranchIds>(
      `${this.franchiseeApiPath}GetPurchaseOrderUserIdsByBranchIds`,
      input
    );
  }

  async getBranchQuoteSupportInbox(
    input: RequestGetBranchQuoteSupportInbox
  ): NullPromise<ResultGetBranchQuoteSupportInbox> {
    return this.api.post<ResultGetBranchQuoteSupportInbox>(
      `${this.franchiseeApiPath}GetBranchQuoteSupportInbox`,
      input
    );
  }
}
